import { createReducer } from "deox";

import {
  pastChargesLoaded,
  pastChargesLoading,
  pastChargesMoreLoaded,
  morePastChargesLoading,
  pastStatementInformationLoaded,
  pastStatementInformationLoading,
  morePastStatementInformationLoaded,
  morePastStatementInformationLoading,
  failed,
  resetStatementInformation,
} from "./pastChargesStateActions"; // Adjust the import path as needed
import { BillingCycleSummary, StatementInformation } from "../../../types/types";
import { purge } from "../purge/purgeStateActions";
export interface PastChargesState {
  pastCharges: BillingCycleSummary[];
  isError: boolean;
  isLoading: boolean;
  isMoreLoading: boolean;
  isLoaded: boolean;
  total: number;
  page: number;
  isLastPage: boolean;
}
export interface StatementInformationState {
  statementInformation: StatementInformation[];
  isError: boolean;
  isLoading: boolean;
  isMoreLoading: boolean;
  isLoaded: boolean;
  total: number;
  page: number;
  isLastPage: boolean;
}
export interface BillingState {
  pastChargesState: PastChargesState;
  statementInformationState: StatementInformationState;
}
const initialState: BillingState = {
  pastChargesState: {
    pastCharges: [],
    isError: false,
    isLoading: false,
    isMoreLoading: false,
    isLoaded: false,
    total: 0,
    page: 1,
    isLastPage: false,
  },
  statementInformationState: {
    statementInformation: [],
    isError: false,
    isLoading: false,
    isMoreLoading: false,
    isLoaded: false,
    total: 0,
    page: 1,
    isLastPage: false,
  },
};
const billingReducer = createReducer(initialState, (handleAction) => [
  // Past Charges Handlers
  handleAction(
    pastChargesLoaded,
    (state, action): BillingState => ({
      ...state,
      pastChargesState: {
        ...state.pastChargesState,
        isLoading: false,
        isLoaded: true,
        isError: false,
        pastCharges: action.payload.records,
        total: action.payload.total,
        page: action.meta,
        isLastPage: action.payload.records.length === 0 || action.payload.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    pastChargesMoreLoaded,
    (state, action): BillingState => ({
      ...state,
      pastChargesState: {
        ...state.pastChargesState,
        isLoading: false,
        isError: false,
        isMoreLoading: false,
        pastCharges: [...state.pastChargesState.pastCharges, ...action.payload.records],
        total: action.payload.total,
        page: action.meta,
        isLastPage: action.payload.records.length === 0 || action.payload.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    pastChargesLoading,
    (state): BillingState => ({
      ...state,
      pastChargesState: {
        ...state.pastChargesState,
        isLoading: true,
        isLoaded: false,
        isMoreLoading: false,
        isError: false,
      },
    })
  ),
  handleAction(
    morePastChargesLoading,
    (state): BillingState => ({
      ...state,
      pastChargesState: {
        ...state.pastChargesState,
        isLoading: false,
        isMoreLoading: true,
        isError: false,
      },
    })
  ),
  // Statement Information Handlers
  handleAction(
    pastStatementInformationLoaded,
    (state, action): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: false,
        isLoaded: true,
        isError: false,
        statementInformation: action.payload.records,
        total: action.payload.total,
        page: action.meta,
        isLastPage: action.payload.records.length === 0 || action.payload.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    morePastStatementInformationLoaded,
    (state, action): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: false,
        isError: false,
        isMoreLoading: false,
        statementInformation: [...state.statementInformationState.statementInformation, ...action.payload.records],
        total: action.payload.total,
        page: action.meta,
        isLastPage: action.payload.records.length === 0 || action.payload.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    pastStatementInformationLoading,
    (state): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: true,
        isLoaded: false,
        isError: false,
      },
    })
  ),
  handleAction(
    morePastStatementInformationLoading,
    (state): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: false,
        isMoreLoading: true,
        isError: false,
      },
    })
  ),
  handleAction(
    resetStatementInformation,
    (state): BillingState => ({
      ...state,
      statementInformationState: {
        ...initialState.statementInformationState,
      },
    })
  ),
  // General Failure Handler
  handleAction(
    failed,
    (state): BillingState => ({
      ...state,
      pastChargesState: {
        ...state.pastChargesState,
        isError: true,
        isLoading: false,
        isMoreLoading: false,
      },
      statementInformationState: {
        ...state.statementInformationState,
        isError: true,
        isLoading: false,
        isMoreLoading: false,
      },
    })
  ),
  // Purge Handler
  handleAction(purge, () => initialState),
]);
export default billingReducer;
